import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import actions from '../reducers/actions'
import Navigation from '../components/Navigation'
import { formatDateTimeNoConversion, getTitle, getDateRange, formatDateRange } from '../utils'
import {
  Button,
  Grid,
  Paper,
  Switch,
  Typography,
} from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { Toast } from 'devextreme-react'
import Welcome from './Welcome'
import TableComponent from '../components/table/TableComponent'
import { isAfter, parseISO } from 'date-fns'
import moment from 'moment'
import { KeyboardDatePicker } from '@material-ui/pickers'
import generateTimesheetsPdf from '../utils/generateTimesheetsPdf'
import { getInvoices, markInvoicesPrinted } from '../service/client'
import round from '../utils/round'
import generateInvoicesPdf from '../utils/generateInvoicesPdf'

const columns = [
  {
    name: 'TimeSheetID',
    title: 'ID',
    width: 75,
    type: 'number'
  },
  {
    name: 'Username',
    title: 'Username',
    width: 125,
    type: 'user'
  },
  {
    name: 'VendorName',
    filterValueField: 'VendorIdd',
    title: 'Vendor Name',
    width: 250,
    type: 'vendor'
  },
  {
    name: 'Evt_Name',
    filterValueField: 'EventIdd',
    title: 'Event',
    width: 150,
    type: 'event',
    getCellValue: row => row.Rows[0]?.Evt_Name
  },
  {
    name: 'DateTimeSaved',
    title: 'Date Saved',
    width: 200,
    type: 'date',
    getCellValue: (row) => row.DateTimeSaved && formatDateTimeNoConversion(row.DateTimeSaved),
    compare: (a, b) => isAfter(parseISO(a), parseISO(b)) ? 1 : -1
  },
  {
    name: 'DateRange',
    title: 'Date Range',
    width: 225,
    type: 'text',
    getCellValue: (row) => getDateRange(row.Rows),
    // getCellValue: (row) => formatDateRange(row.Rows[0]?.StartDate, row.Rows[0]?.EndDate),
  },
  {
    name: 'NumRows',
    title: 'Rows',
    width: 75,
    type: 'number',
    getCellValue: (row) => row.Rows.length,
    // getCellValue: (row) => row.Rows[0]?.count,
  },
  {
    name: 'Submitted',
    title: 'Submitted',
    width: 100,
    type: 'boolean',
  },
  {
    name: 'DatePrinted',
    title: 'Date Printed',
    width: 100,
    type: 'date',
  },
  {
    name: 'hasInvoice',
    title: 'App Invoice',
    width: 100,
    type: 'boolean',
  },
  {
    name: 'invoiceEmailed',
    title: 'Email Invoice',
    width: 100,
    type: 'boolean',
  },
  {
    name: 'invoiceDatePrinted',
    title: 'Invoice Date Printed',
    width: 150,
    type: 'date',
  },
  {
    name: 'options',
    title: 'Options',
    width: 60,
    type: 'options'
  }
]

const formatStr = 'YYYY-MM-DD HH:mm:ss'

function HomePage({
  user, data, getSavedTimeSheets, getCrews, getUserInfo, selectTimeSheet, logout, confirmUser, endImpersonation, setOverrideUrl,
  getRouteInfo, setRealTimeFilters, getTimeSheetListing,
}) {
  const { savedTimeSheets, routeInfo, realTimeFilters } = data

  document.title = getTitle()
  const { vendorIdd, vendors, permissions } = user
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(moment().startOf('day').subtract(2, 'weeks'))
  const [endDate, setEndDate] = useState(moment().endOf('day'))
  const [isPrinted, setIsPrinted] = useState(false)
  const [invoiceIsPrinted, setInvoiceIsPrinted] = useState(false)
  const [overrideUrl, setLocalOverrideUrl] = useState(null)
  const [selection, setSelection] = useState([])
  const [selectionIds, setSelectionIds] = useState([])
  const [toastMessage, setToastMessage] = useState(false)
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLocalOverrideUrl(user.overrideUrl)
  }, [user.overrideUrl])

  useEffect(() => {
    if (overrideUrl !== null && loaded) {
      switchPromises()
    }
  }, [overrideUrl])

  function checkRouteInfo() {
    if (routeInfo.length === 0) {
      getRouteInfo(user).then((r) => {
        printSelectedTimesheets(r.routeInfo)
      })
    } else {
      printSelectedTimesheets()
    }
  }

  function printSelectedTimesheets(newRouteInfo) {
    const ri = newRouteInfo || routeInfo
    const selectedSheetIds = []

    const selectedSheets = selectionIds.map(id => {
      const { Rows, VendorName, ShortNote, LongNote, TimeSheetID, hasInvoice, InvoiceId } = savedTimeSheets.find(t => t.TimeSheetID === id)
      if (hasInvoice) {
        selectedSheetIds.push(InvoiceId)
      }
      const data = Rows.map(r => {
        const newRow = {}
        for (const key of Object.keys(r)) {
          newRow[`${key[0].toLowerCase()}${key.slice(1)}`] = r[key]
        }
        const foundRouteInfo = ri.find(({ PropAgr_ID }) => PropAgr_ID === r.RouteID)
        return {
          ...newRow,
          extraData: foundRouteInfo,
        }
      })

      return {
        data,
        vendor: VendorName,
        shortNote: ShortNote,
        longNote: LongNote,
        timesheetId: TimeSheetID,
        hasInvoice
      }
    })
    const invoiceIds = selectedSheetIds.filter(id => id !== null).join(', ')

    getInvoiceData(user, invoiceIds).then(invoices => {
      generateTimesheetsPdf(selectedSheets, user, invoices, invoiceIds).then(() => {
        setLoading(false)
        setSelection([])
        setSelectionIds([])
        getSheets()
      })
    })
      .catch(e => console.log(e))
  }

  function printSelectedInvoices() {
    const selectedSheetIds = selectionIds.map(id => {
      const sheet = savedTimeSheets.find(t => t.TimeSheetID === id)
      const { InvoiceId, hasInvoice } = sheet
      return hasInvoice ? InvoiceId : null
    })
      .filter(id => id !== null)
      .join(', ')

    if (selectedSheetIds.length > 0) {
      setLoading(true);
      getInvoiceData(user, selectedSheetIds).then(invoices => {
        generateInvoicesPdf(invoices, user).then(() => {
          setLoading(false)
          setSelection([])
          setSelectionIds([])
          getSheets()
        })
          .catch(console.log)
      })
    } else {
      setToastMessage('No timesheets with invoices selected.')
    }
  }

  function getInvoiceData(user, selectedSheetIds) {
    if (selectedSheetIds.length === 0) {
      return Promise.resolve([])
    }
    return getInvoices(user, selectedSheetIds).then(r => {
      const invoices = r.body.map(i => {
        const invoice = {
          ...i,
          lines: JSON.parse(i.lines)
        }
        return prepInvoiceData(invoice)
      })
      return invoices
    })
  }

  function markSelectedPrinted() {
    const selectedSheetIds = selectionIds.map(id => {
      const sheet = savedTimeSheets.find(t => t.TimeSheetID === id)
      const { InvoiceId, invoiceEmailed } = sheet
      return invoiceEmailed ? InvoiceId : null
    })
      .filter(id => id !== null)
      .join(', ')

    if (selectedSheetIds.length > 0) {
      setLoading(true);
      markInvoicesPrinted(user, selectedSheetIds)
        .then(() => {
          setLoading(false)
          setSelection([])
          setSelectionIds([])
          getSheets()
        })
        .catch(() => {
          setToastMessage('There was an error marking the invoices printed.')
          setLoading(false)
        })
    } else {
      setToastMessage('No emailed invoices selected.')
    }
  }

  function prepInvoiceData(d) {
    const prepObj = {
      ...d,
      timesheetId: d.timesheet_id,
      invoiceDate: moment(d.invoice_date).format('MM/DD/YYYY'),
      dueDate: moment(d.due_date).format('MM/DD/YYYY'),
      invoiceNumber: `${d.username}${moment(d.invoice_date).format('MMDDYYhhmmss')}`
    }

    prepObj.rows = d.lines.filter(r => r.item !== '').map(r => {
      return {
        rate: r.rate,
        hours: r.hours_worked,
        amount: round(r.hours_worked * r.rate),
        equipmentType: r.item
      }
    })
    prepObj.total = round(prepObj.rows.reduce((a, b) => a + b.amount, 0))

    return prepObj
  }

  function switchPromises() {
    setLoading(true)
    const promises = [
      getCrews({ ...user, overrideUrl }),
      getUserInfo({ ...user, overrideUrl }),
      getSavedTimeSheets({ ...user, overrideUrl }, startDate.format(formatStr), endDate.format(formatStr))
      // getTimeSheetListing({ ...user, overrideUrl }, startDate.format(formatStr), endDate.format(formatStr))
    ]
    Promise.all(promises)
      .catch(console.log)
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getSheets()
  }, [user.username])

  function getSheets() {
    setLoading(true)
    getSavedTimeSheets(user, startDate.format(formatStr), endDate.format(formatStr), isPrinted, invoiceIsPrinted)
      // getTimeSheetListing(user, startDate.format(formatStr), endDate.format(formatStr), isPrinted, invoiceIsPrinted)
      .then(() => {
        setLoading(false)
        setLoaded(true);
      })
      .catch(e => {
        console.log(e)
        setLoading(false)
      })
  }

  const isAdmin = user.username.toLowerCase() === 'admin'

  return (
    user.confirmed ? (
      <>
        <Grid container style={{ padding: 16 }}>
          <Navigation {...{
            logout: () => logout(user),
            user,
            endImpersonation,
            setOverrideUrl,
            isAdmin,
            switchPromises,
            additionalBtns: (
              <>
                <Button {...{
                  onClick: checkRouteInfo,
                  disabled: selectionIds.length === 0,
                  color: 'inherit',
                  style: { marginLeft: 20 }
                }}>
                  Print Timesheets
                </Button>
                <Button {...{
                  onClick: printSelectedInvoices,
                  disabled: selectionIds.length === 0,
                  color: 'inherit',
                  style: { marginLeft: 20 }
                }}>
                  Print Invoices
                </Button>
                <Button {...{
                  onClick: markSelectedPrinted,
                  disabled: selectionIds.length === 0,
                  color: 'inherit',
                  style: { marginLeft: 20 }
                }}>
                  Mark Email Printed
                </Button>
              </>
            )
          }}
          />
          <Paper style={{ marginTop: 65 }}>
            <Grid
              container
              style={{ padding: 10, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 10, alignItems: 'center', width: 'calc(100vw - 32px)' }}
            >
              <Typography
                variant="h4"
                color="primary"
              >
                Time Sheets
              </Typography>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 10, alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Switch
                    checked={isPrinted}
                    onChange={(e) => setIsPrinted(e.target.checked)}
                  />
                  <div>Only Unprinted</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Switch
                    checked={invoiceIsPrinted}
                    onChange={(e) => setInvoiceIsPrinted(e.target.checked)}
                  />
                  <div>Only Unprinted Invoices</div>
                </div>
                <KeyboardDatePicker
                  {...{
                    handleFilterChanged: (o) => setEndDate(o.value),
                    style: { margin: 2, marginBottom: 4 },
                    value: startDate,
                    format: 'MM/dd/yyyy',
                    onChange: (e) => setStartDate(moment(e)),
                    InputAdornmentProps: { position: 'start', style: { marginRight: 0 } },
                    KeyboardButtonProps: { style: { padding: 2 } },
                  }}
                />
                <KeyboardDatePicker
                  {...{
                    handleFilterChanged: (o) => setEndDate(o.value),
                    style: { margin: 2, marginBottom: 4 },
                    value: endDate,
                    format: 'MM/dd/yyyy',
                    onChange: (e) => setEndDate(moment(e)),
                    InputAdornmentProps: { position: 'start', style: { marginRight: 0 } },
                    KeyboardButtonProps: { style: { padding: 2 } },
                  }}
                />
                <Button onClick={getSheets} color='primary' variant='contained'>
                  Go
                </Button>
              </div>
              <Button
                style={{ margin: 'auto 0' }}
                variant="contained"
                color="primary" onClick={() => selectTimeSheet(null)}
              >
                <Add />
                Enter New Time Sheet
              </Button>
            </Grid>
            <div style={{ width: 'calc(100vw - 32px)' }}>
              <TableComponent {...{
                columns,
                rows: savedTimeSheets,
                loading,
                selectTimeSheet,
                isAdmin,
                selection,
                setSelection,
                setSelectionIds,
                realTimeFilters,
                setRealTimeFilters,
              }}
              />
            </div>
          </Paper>

        </Grid>
        <Toast
          visible={!!toastMessage}
          message={toastMessage}
          type='error'
          onHiding={() => setToastMessage(false)}
          displayTime={4000}
        />
      </>
    ) :
      <Welcome {...{ user, confirmUser }} />
  )
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default connect(mapStateToProps, actions)(HomePage)